export const Chips: ng.IComponentOptions = {
  bindings: {
    label: '@',
    placeholder: '@',
    model: '='
  },
  templateUrl: 'app/angularJS/components/chips/chips.html'
};